import { useNavigate, useSearchParams } from 'react-router-dom';
import styles from './PaymentFailPage.module.css';

function PaymentFailPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const message = searchParams.get('message') || '결제에 실패했습니다.';

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.icon}>✕</div>
                <h2 className={styles.title}>결제 실패</h2>
                <p className={styles.message}>{message}</p>
                <div className={styles.buttons}>
                    <button className={styles.btnPrimary} onClick={() => navigate('/cart')}>
                        장바구니로 돌아가기
                    </button>
                    <button className={styles.btnOutline} onClick={() => navigate('/products')}>
                        쇼핑 계속하기
                    </button>
                </div>
            </div>
        </div>
    );
}

export default PaymentFailPage;